import { apiRequest } from './api';

export async function getAboutUs() {
  return apiRequest('/api/about_us', {
    method: 'GET',
    allowNotFound: true,
  });
}
